import { render, staticRenderFns } from "./sys_home_set.vue?vue&type=template&id=bc2615fa&scoped=true"
import script from "./sys_home_set.vue?vue&type=script&lang=js"
export * from "./sys_home_set.vue?vue&type=script&lang=js"
import style0 from "./sys_home_set.vue?vue&type=style&index=0&id=bc2615fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2615fa",
  null
  
)

export default component.exports